const logBookingEngineConversion = async () => {
  const response = await fetch('/api2/abtesting/logbookingconversion', { method: 'POST' })

  if (!response.ok) {
    throw new Error('AB Test Logger: An unexpected error occurred whilst logging a booking engine conversion.')
  }
}

export { logBookingEngineConversion }
